<template>
  <div id="scoreLineSet">
    <template v-if="$route.name === 'scoreLineSet'">
      <ots-main-title></ots-main-title>
      <div class="planSelectCss">
        考试批次：
        <el-select v-model="planId" placeholder="请选择考试批次" filterable>
          <el-option
            v-for="item in planList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <font v-if="isShowTip" class="tipClass">当前批次只对应一门课程，不可进行后续设置，请重新选择其他批次。</font>
      </div>
      <div class="section" v-if="isShowNext">
        <div class="divLeft">
          <el-form label-width="180px" :inline="false">
            <el-form-item label="设置课程类别：">
              <el-input placeholder="请输入课程类别" ref="courseNameLeftInput" v-model="courseNameLeft"></el-input>
            </el-form-item>
            <el-form-item label="设置分控线(%)：">
              <el-input placeholder="请输入分控线" v-model="scoreLeft" ref="scoreLeftInput" @input="validateNumberInput($event, 1)"></el-input>
            </el-form-item>
            <el-form-item label="选择课程：">
              <div class="stationBox">
                <div class="stationTop">
                  <div class="searchCourse">
                    快捷搜索：<el-input placeholder="输入课程模糊搜索" v-model="searchNameLeft"></el-input>
                    <div class="searchPos">
                      <i class="iconfont icon-sousuo"></i>
                    </div>
                  </div>
                </div>
                <div class="divTHCss">
                  <div class="orderCss">序号</div>
                  <div>课程名称</div>
                  <div class="rightTip">共 {{ courseDataLeftCount }} 门课程</div>
                </div>
              </div>
              <div class="ulBox">
                <div v-for="(item, index) in courseDataLeftList" :key="index" class="divTHCss">
                  <div class="orderCss">{{ item.orderId }}</div>
                  <div class="nameCss" :class="{ active: selectedLeftIdList.includes(item.id) }" @click="dealLeft(item.id)">{{ item.name }}</div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="divMiddle">
          <el-tooltip content="全部右移" placement="right-start">
            <el-button type="primary" icon="el-icon-d-arrow-right" circle @click="moveCourse(4)"></el-button>
          </el-tooltip><br/>
          <el-tooltip content="选中项右移" placement="right-start">
            <el-button type="success" icon="el-icon-arrow-right" circle @click="moveCourse(3)"></el-button>
          </el-tooltip><br/>
          <el-tooltip content="选中项左移" placement="right-start">
            <el-button type="success" icon="el-icon-arrow-left" circle @click="moveCourse(2)"></el-button>
          </el-tooltip><br/>
          <el-tooltip content="全部左移" placement="right-start">
            <el-button type="primary" icon="el-icon-d-arrow-left" circle @click="moveCourse(1)"></el-button>
          </el-tooltip><br/>
        </div>
        <div class="divRight">
          <el-form label-width="150px" :inline="true">
            <el-form-item label="设置课程类别：">
              <el-input placeholder="请输入课程类别" ref="courseNameRightInput" v-model="courseNameRight"></el-input>
            </el-form-item>
            <el-form-item label="设置分控线(%)：">
              <el-input placeholder="请输入分控线" v-model="scoreRight" ref="scoreRightInput" @input="validateNumberInput($event, 2)"></el-input>
            </el-form-item>
            <el-form-item label="选择课程：">
              <div class="stationBox">
                <div class="stationTop">
                  <div class="searchCourse">
                    快捷搜索：<el-input placeholder="输入课程模糊搜索" v-model="searchNameRight"></el-input>
                    <div class="searchPos">
                      <i class="iconfont icon-sousuo"></i>
                    </div>
                  </div>
                </div>
                <div class="divTHCss">
                  <div class="orderCss">序号</div>
                  <div>课程名称</div>
                  <div class="rightTip">共 {{ courseDataRightCount }} 门课程</div>
                </div>
              </div>
              <div class="ulBox">
                <div v-for="(item, index) in courseDataRightList" :key="index" class="divTHCss">
                  <div class="orderCss">{{ item.orderId }}</div>
                  <div class="nameCss" :class="{ active: selectedRightIdList.includes(item.id) }" @click="dealRight(item.id)">{{ item.name }}</div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </template>
    <template v-else>
        <router-view></router-view>
    </template>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import { getPlanCourseFn } from "@/http/modules/baseSet/course";
import { saveScoreLineFn } from "@/http/modules/examSet/score";

export default {
  name: 'scoreLineSet',
  data() {
    return {
      planId: '',
      planList: [],
      isShowTip: false,
      isShowNext: false,
      courseNameLeft: '学位外语课程',
      courseNameRight: '学位专业综合课程',
      scoreLeft: '',
      scoreRight: '',
      searchNameLeft: '',
      searchNameRight: '',
      selectedLeftIdList: [],
      selectedRightIdList: [],
      courseDataList: [],
      saveMethods: "submitForm",
      backMethods: "goBack",
    };
  },
  created() {
    this.getPlanInfo();
  },
  mounted() {
    this.SAVE_PAGE_THIS(this);
  },
  computed: {
    courseDataLeftList() {
      if(this.searchNameLeft) {
        this.selectedLeftIdList = [];
        return this.courseDataList.filter(item => item.groupFlag == true).filter(item => item.name.includes(this.searchNameLeft));
      }else{
        return this.courseDataList.filter(item => item.groupFlag == true);
      }
    },
    courseDataRightList() {
      if(this.searchNameRight) {
        this.selectedRightIdList = [];
        return this.courseDataList.filter(item => item.groupFlag == false).filter(item => item.name.includes(this.searchNameRight));
      }else{
        return this.courseDataList.filter(item => item.groupFlag == false);
      }
    },
    courseDataLeftCount() {
      return this.courseDataList.filter(item => item.groupFlag == true).length;
    },
    courseDataRightCount() {
      return this.courseDataList.filter(item => item.groupFlag == false).length;
    }
  },
  watch: {
    "planId"(val){
      this.isShowTip = false;
      this.getPlanCourseInfo(val);
    },
  },
  methods: {
    ...mapMutations(["SAVE_PAGE_THIS"]),

    getPlanInfo(){
      getSelectPlanFn({needAudit:6}).then(res => {
        if(res.code == 1){
          this.planList = res.data;
          if(this.planList.length > 0){
            this.planId = res.data[0].id;
          }
        }
      })
    },
    getPlanCourseInfo(val){
      this.courseDataList = [];
      getPlanCourseFn({ planId: val }).then(res => {
        if(res.code == 1){
          if(res.data){
            if(res.data.length <= 1){
              this.isShowTip = true;
              this.isShowNext = false;
              return;
            }else{
              this.isShowTip = false;
              this.isShowNext = true;
            }
          }else{
            this.isShowTip = true;
            this.isShowNext = false;
            return;
          }
          let j = 1;
          res.data.forEach(item => {
            this.courseDataList.push({
              orderId: j,
              id: item.courseId,
              name: item.courseName,
              groupFlag: true, //默认都在左边，如果默认都在右边，把这个改成false就行
            })
            j++;
          })
        }
      })
    },
    submitForm() {
      if(this.isShowTip){
        return;
      }
      if(this.courseNameLeft == ''){
        this.$message.warning("请先设置左侧课程类别名称");
        this.$refs.courseNameLeftInput.focus();
        return;
      }
      if(this.scoreLeft == ''){
        this.$message.warning(`【${this.courseNameLeft}】的分控线不能为空`);
        this.$refs.scoreLeftInput.focus();
        return;
      }
      if(this.courseNameRight == ''){
        this.$message.warning("请先设置右侧课程类别名称");
        this.$refs.courseNameRightInput.focus();
        return;
      }
      if(this.scoreRight == ''){
        this.$message.warning(`【${this.courseNameRight}】的分控线不能为空`);
        this.$refs.scoreRightInput.focus();
        return;
      }
      if(this.courseNameLeft == this.courseNameRight){
        this.$message.warning("左右两侧课程类别名称不能相同");
        return;
      }
      let leftIdList = this.courseDataList.filter(item => item.groupFlag == true).map(item => item.id);
      let rightIdList = this.courseDataList.filter(item => item.groupFlag == false).map(item => item.id);
      if(leftIdList.length == 0){
        this.$message.warning(`请先设置【${this.courseNameLeft}】对应的课程`);
        return;
      }
      if(rightIdList.length == 0){
        this.$message.warning(`请先设置【${this.courseNameRight}】对应的课程`);
        return;
      }

      let params = {
        planId: this.planId,
        groupName4A:  this.courseNameLeft,
        groupValue4A: this.scoreLeft,
        courseIds4A:  leftIdList.join(","),
        groupName4B:  this.courseNameRight,
        groupValue4B: this.scoreRight,
        courseIds4B:  rightIdList.join(","),
      }
      saveScoreLineFn(params).then(res => {
        if(res.code == 1){
          this.$message.success('设置成功!');
          this.goBack(res.data.batchSetId);
        }
      })
    },
    goBack(val){
      if(val){
        this.$router.push({ name: "scoreLine", query: { id: val }});
      }else{
        this.$router.push({ name: "scoreLine" });
      }
    },
    validateNumberInput(value,index) {
      let filtered = value.replace(/[^\d.]/g, '');
      if (filtered.startsWith('.')) {
        filtered = filtered.substring(1);
      }
      const dotCount = (filtered.match(/\./g) || []).length;
      if (dotCount > 1) {
        filtered = filtered.replace(/\./g, '', dotCount - 1);
      }
      const parts = filtered.split('.');
      parts[0] = parts[0].slice(0, 3);
      if (parts.length > 1) {
        parts[1] = parts[1].slice(0, 2);
      }
      if(index==1){
        this.scoreLeft=parts.join('.');
      }else{
        this.scoreRight=parts.join('.');
      }
    },
    dealLeft(val){
      if(val){
        if(!this.selectedLeftIdList.includes(val)){
          this.selectedLeftIdList.push(val);
        }else{
          this.selectedLeftIdList = this.selectedLeftIdList.filter(item => item != val);
        }
      }
    },
    dealRight(val){
      if(val){
        if(!this.selectedRightIdList.includes(val)){
          this.selectedRightIdList.push(val);
        }else{
          this.selectedRightIdList = this.selectedRightIdList.filter(item => item != val);
        }
      }
    },
    moveCourse(val){
      if(val == 1){
        if(this.searchNameRight){
          this.courseDataList.filter(item=>!item.groupFlag).filter(item => item.name.includes(this.searchNameRight)).forEach(item => item.groupFlag = true);
        }else{
          this.courseDataList.forEach(item => item.groupFlag = true);
        }
      }else if(val == 2){
        this.selectedRightIdList.forEach(item => {
          this.courseDataList.forEach(item1 => {
            if(item1.id == item){
              item1.groupFlag = true;
            }
          })
        });
      }else if(val == 3){
        this.selectedLeftIdList.forEach(item => {
          this.courseDataList.forEach(item1 => {
            if(item1.id == item){
              item1.groupFlag = false;
            }
          })
        });
      }else if(val == 4){
        if(this.searchNameLeft){
          this.courseDataList.filter(item=>item.groupFlag).filter(item => item.name.includes(this.searchNameLeft)).forEach(item => item.groupFlag = false);
        }else{
          this.courseDataList.forEach(item => item.groupFlag = false);
        }
      }else{}

      if(val == 1 || val == 4){
        this.selectedLeftIdList = [];
        this.selectedRightIdList = [];
      }
      if(val == 2){
        this.selectedRightIdList = [];
      }
      if(val == 3){
        this.selectedLeftIdList = [];
      }
    }
  },
};
</script>

<style lang="less" scoped>
.tipClass{
  margin-left: 20px;
  color: #F56C6C;
}
.planSelectCss{
  background-color: #ffffff;
  border-radius: 5px;
  padding:20px;
  /deep/ .el-select{
    width: 300px !important;
    .el-input__inner{
      width: 300px !important;
      padding-right: 10px;
    }
  }
  /deep/ .el-input{
    width:300px !important;
  }
}
.section {
  margin-top:10px;
  display: flex;
  background-color: #ffffff;
  border-radius: 5px;
  padding: 10px;
  .divLeft{
    width:47%;
    background-color: #F5F7FA;
    border-radius: 5px;
    padding-top:20px;
  }
  .divMiddle{
    padding-top: 250px;
    width:6%;
    text-align: center;
    background-color: #FFFFFF;
    height: 50px;
    line-height: 50px;
  }
  .divRight{
    width:47%;
    background-color: #F5F7FA;
    border-radius: 5px;
    padding-top:20px;
  }
  .stationBox {
    width: 350px;
    background-color: #ffffff;
    overflow-y: auto;
    padding: 10px 30px 0px 20px;
    border-radius: 8px 8px 0 0;
    .stationTop {
      display: flex;
      margin-bottom: 10px;
    }
    .searchCourse {
      position: relative;
      .searchPos {
        width: 40px;
        height: 18px;
        line-height: 18px;
        border-left: 1px solid #e1e6ed;
        position: absolute;
        right: 0;
        top: 11px;
        color: #c2c6cc;
        font-size: 14px;
        i {
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }
    .divTHCss{
      display: flex;
      border-bottom: 1px solid #E1E6ED;
      font-weight: bold;
      .orderCss{
        padding-left: 10px;
        width:60px;
      }
    }
  }
  .ulBox {
    width: 400px;
    min-height: 272px;
    max-height: 272px;
    background-color: #ffffff;
    overflow-y: auto;
    border-radius: 0 0 8px 8px;
    padding-top:5px;
    .divTHCss{
      display: flex;
      .orderCss{
        padding-left: 40px;
        width: 50px;
      }
      .nameCss{
        cursor: pointer;
        width:270px;
      }
      .nameCss:hover{
        color: #409EFF;
        cursor: pointer;
      }
      .nameCss.active{
        color:#F56C6C;
        font-weight: bold;
      }
    }
  }
  .rightTip{
    width: 220px;
    text-align: right;
    font-size: 12px;
    font-weight: normal;
  }
  /deep/ .el-form-item {
    margin-bottom: 20px !important;
  }
}
</style>